import { _baseClient } from '../index';
import { clearUser } from '../../stores/auth.js';

export const logout = async () => {
  return clearUser();
};
export const getProfile = () => {
  return _baseClient.get('/profile/get');
};
export const saveProfile = (params) => {
  return _baseClient.post('/profile/save', { body: params });
};
